<template>
  <div>
    <v-snackbar
      v-model="showNotification"
      :timeout="timeout"
      :top="true"
      dark
      :color="color"
    >
      {{ notificationMsg }}
    </v-snackbar>
    <v-form
      class="px-3"
      ref="form"
      @submit.prevent="submit"
      v-if="!showMailVerification"
    >
      <v-card flat outlined width="550" class="mx-auto my-10">
        <v-progress-linear
          class="mt-n1"
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-linear>
        <div class="pa-4 pb-0">
          <div class="d-flex justify-center align-items-center mt-6">
            <v-img :src="require('@/assets/logo_org.png')" max-width="120">
            </v-img>
          </div>

          <v-card-title class="justify-center pt-6 pb-4 text-h5"
            >Create your account</v-card-title
          >
          <v-card-text>
            <v-text-field
              v-model="name"
              prepend-icon="mdi-account-circle"
              :rules="inputRules"
            >
              <template v-slot:label>
                Name
                <span class="red--text">*</span>
              </template>
            </v-text-field>
            <v-text-field
              v-model="email"
              prepend-icon="mdi-email"
              :rules="emailRules"
            >
              <template v-slot:label>
                Email
                <span class="red--text">*</span>
              </template>
            </v-text-field>

            <v-select
              v-model="selectedOrgType"
              :items="orgTypes"
              item-text="title"
              item-value="title"
              prepend-icon="mdi-format-align-left"
              :rules="inputRules"
            >
              <template v-slot:label>
                Type of organization
                <span class="red--text">*</span>
              </template>
            </v-select>

            <v-text-field
              v-model="password"
              type="password"
              prepend-icon="mdi-key-variant"
              :rules="[passwordRules.required, passwordRules.minlength]"
            >
              <template v-slot:label>
                Password
                <span class="red--text">*</span>
              </template>
            </v-text-field>

            <v-text-field
              v-model="confirmpassword"
              type="password"
              prepend-icon="mdi-key-variant"
              required
              :rules="repeatPasswordRules"
            >
              <template v-slot:label>
                Confirm Password
                <span class="red--text">*</span>
              </template>
            </v-text-field>
             <v-flex>
            <v-checkbox
              id = "shareBtn"
              v-model="isProjectInfoShareable"
              label="Permit project data to be shared publicly"
              color="primary"
              prepend-icon="mdi-share-variant"
              hide-details
            />
          </v-flex>
          <div class="px-8 text-subtitle1 mt-4">
            Note: This setting allows Solva & Auroville Consulting to share project information, load profile data and reports publicly. When this is not selected, you will not be able to publish projects.
            Published projects allow all users on Solva to view project data and reports.
          </div>
            <v-row>
              <v-col cols="6" sm="9" class="pb-5">
                <v-container fluid>
                  <v-checkbox
                    v-model="isTermsChecked"
                    color="primary"
                    hide-details
                    :rules="termsrules"
                  >
                    <template v-slot:label>
                      Accept Terms and Conditions
                      <v-dialog
                        v-model="showTermsDialog"
                        width="680px"
                        persistent
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <a
                            v-on="on"
                            v-bind="attrs"
                            class="ma-1"
                            plain
                            @click="preventClick"
                          >
                            [Read]
                          </a>
                        </template>
                        <div class="my-n8">
                        <TermsAndConditions />
                        </div>
                        <v-sheet>
                          <v-card-actions class="pb-4">
                            <v-spacer></v-spacer>
                            <v-btn text @click="closeDialog(false)">
                              Decline
                            </v-btn>
                            <v-btn
                              color="primary"
                              text
                              @click="closeDialog(true)"
                            >
                              Accept
                            </v-btn>
                          </v-card-actions>
                        </v-sheet>
                      </v-dialog>
                    </template>
                  </v-checkbox>
                </v-container>
              </v-col>
            </v-row>
            <template>
              <v-flex>
                <v-checkbox
                  v-model="isSubscribedToNewsletter"
                  label="Subscribe Newsletter"
                  color="primary"
                />
              </v-flex>
            </template>
          </v-card-text>
          <div class="d-flex justify-center align-center mb-8">
            <v-btn color="primary" type="submit" :loading="loading">
              Create Account
            </v-btn>
          </div>
          <v-divider></v-divider>

          <v-card-actions class="pa-4 justify-center align-center">
            <div
              class="text-body-1 font-weight-regular mr-1"
              style="padding-top: 2px"
            >
              Already have an account?
            </div>

            <v-btn
              text
              color="primary"
              router
              :to="'/login'"
              class="text-capitalize"
              style="font-size: 1rem"
              >Login</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-form>
    <v-form
      class="px-3"
      ref="form2"
      @submit.prevent="verifyEmail"
      v-if="showMailVerification"
    >
      <v-card flat outlined width="500" class="mx-auto my-10">
        <v-progress-linear
          class="mt-n1"
          indeterminate
          color="primary"
          v-if="loading"
        ></v-progress-linear>
        <div class="px-4">
          <div class="d-flex justify-center align-items-center mt-6">
            <v-img :src="require('@/assets/logo_org.png')" max-width="120">
            </v-img>
          </div>
          <v-card-title class="justify-center text-center pt-6 pb-8 text-5"
            >Email Verification</v-card-title
          >
          <v-card-text class="text-body-1"
            >An 8 digit verification code has been sent to your email address.
            <br /><br />Please enter the code below
          </v-card-text>
          <v-card-text class="text-center pt-0">
            <div class="d-flex align-items-center justify-center">
              <v-text-field
                v-model="verificationCode"
                type="text"
                prepend-icon="mdi-key-variant"
                required
                :rules="[
                  verificationCodeRules.exactlength,
                  verificationCodeRules.required,
                ]"
                style="max-width: 300px"
              >
                <template v-slot:label>
                  Verification Code
                  <span class="red--text">*</span>
                </template>
              </v-text-field>
            </div>
            <v-btn
              color="primary"
              type="submit"
              :loading="loading"
              class="text-capitalize mt-6"
            >
              Submit
            </v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="subtitle"
            >Note: Please check your spam folder in case the email does not
            appear in your inbox.</v-card-text
          >
        </div>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import registrationService from "@/libs/registrationService.js";
import TermsAndConditions from "@/views/Terms";
import dataService from "@/libs/dataService.js";
export default {
  name: "Registration",
  components: {
    TermsAndConditions,
  },
  data() {
    return {
      orgTypes: [],
      selectedOrgType: null,
      isProjectInfoShareable: true,
      isSubscribedToNewsletter: false,
      isTermsChecked: false,
      showpassword: false,
      name: "",
      email: "",
      type: "",
      password: "",
      confirmpassword: "",
      notificationMsg: "",
      loading: false,
      validPassword: "",
      inputRules: [(v) => !!v || "This field is required"],
      passwordRules: {
        minlength: (v) =>
          (v && v.length >= 8) || "This field must have at least 8 characters",
        required: (v) => !!v || "This field is required",
      },
      verificationCodeRules: {
        exactlength: (v) => (v && v.length === 8) || "Invalid code",
        required: (v) => !!v || "This field is required",
      },
      termsrules: [(v) => !!v || "This field is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      showNotification: false,
      timeout: 5000,
      y: "top",
      color: "orange",
      showTermsDialog: false,
      showMailVerification: false,
      verificationCode: "",
    };
  },
  computed: {
    repeatPasswordRules() {
      return [
        (v) => !!v || "This field is required",
        (v) => (v && v.length >= 8) || "Minimum 8 characters",
        (v) => v === this.password || "Password does not match",
      ];
    },
  },
  created() {
    this.getOrganizationTypes();
  },
  methods: {
    closeDialog(acceptTerms) {
      this.isTermsChecked = acceptTerms;
      this.showTermsDialog = false;
    },
    preventClick(e) {
      e.preventDefault();
    },
    getOrganizationTypes() {
      dataService
        .list("organizationTypes")
        .then((res) => (this.orgTypes = res));
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const payload = {
          name: this.name,
          email: this.email,
          organizationType: this.selectedOrgType,
          password: this.password,
          settings: {
            isProjectInfoShareable: this.isProjectInfoShareable,
            isSubscribedToNewsLetter: this.isSubscribedToNewsletter
          }
        };
        registrationService
          .signup(payload)
          .then((res) => {
            this.color = "green";
            this.showNotification = true;
            this.loading = false;
            this.$refs.form.reset();
            this.email = payload.email;
            this.notificationMsg = res.data.message;
            this.showMailVerification = true;
          })
          .catch((error) => {
            this.color = "red";
            this.notificationMsg = 'An error occurred while creating your account';
            if (error.response) {
              const { data } = error.response;
              if (data.message) {
                this.notificationMsg = data.message;
              }
            }
            this.showNotification = true;
            this.loading = false;
          });
      }
    },
    verifyEmail() {
      if (this.$refs.form2.validate()) {
        const payload = {
          email: this.email,
          code: this.verificationCode
        };
        this.loading = true;
        registrationService
          .verifyEmail(payload)
          .then((res) => {
            if (res.data && res.data.success === true && res.data.message) {
              this.color = "green";
              this.notificationMsg = res.data.message;
              this.showNotification = true;
            }
            this.$refs.form2.reset();
            this.showMailVerification = false;
            setTimeout(() => {
              this.showNotification = false;
              this.notificationMsg = "Redirecting to login page...";
              this.showNotification = true;
              this.loading = false;
              setTimeout(() => {
                this.$router.push("/login");
              }, 4000);
            }, 2000);
          })
          .catch((error) => {
            this.color = "red";
            this.notificationMsg =
              "An error occured while verifying your email address";
            if (error.response) {
              const { data } = error.response;
              if (data.message) {
                this.notificationMsg = data.message;
              }
            }
            this.showNotification = true;
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style>
.container {
  padding: 0 !important;
}
.v-dialog {
  overflow-x: hidden !important;
}
</style>